import React, { useEffect, useState } from 'react'

interface TickUpdatedProps {
  currentValue: (now: number) => React.ReactNode
}

export function TickUpdated({ currentValue }: TickUpdatedProps) {
  const [value, setValue] = useState(currentValue(Date.now()))

  // Tyler says: I'm not *thrilled* with the use of hooks here, but
  // because the state is purely derived from the start time, and
  // extremely transient, it seems okay.
  // The truth is we really just need a way to tickle the render
  // once a second...
  useEffect(() => {
    const interval = setInterval(() => {
      setValue(currentValue(Date.now()))
    }, 1000)

    return () => clearInterval(interval)
  }, [currentValue])

  return value
}
